import { ICompileService } from "angular";
import { RecordDataSource } from "../../../records/grids";
import {
  ColumnDefinitionService,
  vsName as ColumnDefinitionServiceName,
} from "../../../records/grids/columns/columnDefinitionService";
import {
  GridSettingsService,
  vsName as GridSettingsServiceName,
  IGridSettings,
} from "../../../records/grids/settings/gridSettingsService";
import {
  ServerUtility,
  vsName as ServerUtilityName,
} from "../../../records/server/serverUtility";
import {
  GridConfiguration,
  RecordGridViewServiceProvider,
  vsProviderName as RecordGridViewServiceProviderName,
} from "../../../records/views/recordGridView";

export const vsObjectName = "progressiveDefinition";

const url = "/api/machines/progressives/ProgressiveDefinition";

ProgressiveDefinition.$inject = [RecordGridViewServiceProviderName];
export function ProgressiveDefinition(
  recordGridViewServiceProvider: RecordGridViewServiceProvider
) {
  recordGridViewServiceProvider.addGridConfiguration(vsObjectName, [
    ColumnDefinitionServiceName,
    ServerUtilityName,
    GridSettingsServiceName,
    "$compile",
    (
      columnDefinitionService: ColumnDefinitionService,
      serverUtility: ServerUtility,
      gridSettingsService: GridSettingsService,
      $compile: ICompileService
    ) => {
      const gridSettings = gridSettingsService.getGridSettings(
        Symbol("main.machines.progressives.grid")
      );

      return getBaseProgressiveDefinitionGrid(
        columnDefinitionService,
        serverUtility,
        gridSettings,
        $compile,
        url
      );
    },
  ]);
}

export function getBaseProgressiveDefinitionGrid(
  columnDefinitionService: ColumnDefinitionService,
  serverUtility: ServerUtility,
  gridSettings: IGridSettings,
  $compile: ICompileService,
  url: string
): GridConfiguration {
  return {
    columns: [
      columnDefinitionService.getNumberColDef({ field: "Id", hide: true }),
      columnDefinitionService.getStringColDef({
        field: "GameProgramNumber",
      }),
      columnDefinitionService.getStringColDef({
        field: "ProgressiveDefinitionName",
        header: "Progressive Definition",
      }),
    ],
    defaultSort: "GameProgramNumber,ProgressiveDefinitionName",
    gridDataSource: new RecordDataSource(serverUtility, url),
    nameSingular: "Progressive Definition",
    showAddButton: true,
    showAddButtonPermission: "machineEdit",
    gridSettings,
  };
}
